export default () => {
  const lang = navigator.language || navigator.userLanguage;
  const isJapanese = lang && lang.toLowerCase().includes('ja');
  const currentPath = window.location.pathname; // 例: /sample/
  const isEnglishPath = currentPath.startsWith('/en/');
  if (!isJapanese && !isEnglishPath) {
    // 英語ブラウザ ＆ まだ /en/ でない場合
    window.location.href = `/en${currentPath}`;
  }
  if (isJapanese && isEnglishPath) {
    // 日本語ブラウザ ＆ /en/ にいる場合
    window.location.href = currentPath.replace(/^\/en/, '');
  }
};
